'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContainer = exports.mapStateToProps = exports.Footer = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _AppDownloads = require('components/AppDownloads');

var _LocaleSwitcherContainer = require('components/LocaleSwitcher/LocaleSwitcherContainer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = exports.Footer = function Footer(_ref) {
  var isBridgeApp = _ref.isBridgeApp,
      _ref$showFooter = _ref.showFooter,
      showFooter = _ref$showFooter === undefined ? true : _ref$showFooter;
  return showFooter && _react2.default.createElement(
    'footer',
    { className: 'footer' },
    _react2.default.createElement(
      'div',
      { className: 'wrap' },
      _react2.default.createElement(
        'div',
        { className: 'footer__links__primary' },
        _react2.default.createElement(
          'div',
          { className: 'grid' },
          _react2.default.createElement(
            'div',
            { className: 'grid__item 1/2 md-1/4' },
            _react2.default.createElement(
              'h5',
              { className: 'footer__header' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.company', defaultMessage: 'Company' })
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/about', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.about-link', defaultMessage: 'About us' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/fitness' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.fitness-link', defaultMessage: 'Why studio fitness' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/gifts' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.gifts-link', defaultMessage: 'Gifts' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/about/careers', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.jobs-link', defaultMessage: 'Careers' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '/press-room', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.press-link', defaultMessage: 'Press' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/go', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.classpass-go-link', defaultMessage: 'ClassPass Go' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/try/corporate', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.corporate', defaultMessage: 'Corporate Memberships' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'grid__item 1/2 md-1/4' },
            _react2.default.createElement(
              'h5',
              { className: 'footer__header' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.support', defaultMessage: 'Support' })
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/contact', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.contact-link', defaultMessage: 'Contact' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '//help.classpass.com', target: '_blank', rel: 'noopener noreferrer' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.help-center-link', defaultMessage: 'Help Center' })
                )
              )
            ),
            !isBridgeApp && _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                'h5',
                { className: 'footer__header locale-switcher' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.language', defaultMessage: 'Language' })
              ),
              _react2.default.createElement(_LocaleSwitcherContainer.LocaleSwitcherContainer, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'grid__item 1/2 md-1/4' },
            _react2.default.createElement(
              'h5',
              { className: 'footer__header' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.partners', defaultMessage: 'Partners' })
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '//studios.classpass.com' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.studios-link', defaultMessage: 'Become a Partner' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '//afterclass.classpass.com', target: '_blank', rel: 'noopener noreferrer' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.studios-blog-link', defaultMessage: 'After Class Blog' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/studios/out-of-network', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.studios-inactive-link', defaultMessage: 'Out of Network Studios' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'grid__item 1/2 md-1/4' },
            _react2.default.createElement(
              'h5',
              { className: 'footer__header' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.community', defaultMessage: 'Community' })
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '/blog', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.blog-link', defaultMessage: 'Blog' })
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '/lists/cities', target: '_self' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.top-lists-link', defaultMessage: 'Top 10 Lists' })
                )
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'footer__links__secondary' },
        _react2.default.createElement(
          'div',
          { className: 'grid' },
          _react2.default.createElement(
            'div',
            { className: 'grid__item md-1/2' },
            _react2.default.createElement(
              'h5',
              { className: 'footer__header mt0' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.downloads', defaultMessage: 'Enjoy fitness on the go' })
            ),
            _react2.default.createElement(_AppDownloads.AppDownloadIcons, { extraClass: 'app-download-icons--small' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'grid__item md-1/2' },
            _react2.default.createElement(
              'div',
              { className: 'footer__icons' },
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--fb-white', href: '//www.facebook.com/classpass', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.facebook', defaultMessage: 'Facebook' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--tw-white', href: '//twitter.com/classpass', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.twitter', defaultMessage: 'Twitter' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--ig-white', href: '//instagram.com/classpass', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.instagram', defaultMessage: 'Instagram' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--pt-white', href: '//www.pinterest.com/classpass/', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.pinterest', defaultMessage: 'Pinterest' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--sp-white', href: '//play.spotify.com/user/classpass/', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.spotify', defaultMessage: 'Spotify' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { className: 'icon icon--28 icon--tb-white', href: '//classpass.tumblr.com', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'service.tumblr', defaultMessage: 'Tumblr' })
                  )
                )
              ),
              _react2.default.createElement(
                'ul',
                { className: 'footer__legal' },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '/terms', target: '_self' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.terms-link', defaultMessage: 'Terms of Use' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '/privacy', target: '_self' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.privacy-link', defaultMessage: 'Privacy Policy' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '/privacy#cookies', target: '_self' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.cookies-link', defaultMessage: 'Cookies & ads' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '/about/accessibility', target: '_self' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.accessibility-link', defaultMessage: 'Accessibility' })
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}; /**
    * Site-wide footer
    */

Footer.propTypes = {
  showFooter: _propTypes2.default.bool
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    showFooter: !state.page.reducedFooter
  };
};

var FooterContainer = exports.FooterContainer = (0, _reactRedux.connect)(mapStateToProps)(Footer);